import React from 'react';
import './App.css';

function App() {
  return (
    <main className="page">
      <h1>Tenor Biel</h1>
      <p>2026 — coming soon.</p>
    </main>
  );
}

export default App;
